import { render, staticRenderFns } from "./TextareaStripTags.vue?vue&type=template&id=0e4dcd7a&scoped=true&"
import script from "./TextareaStripTags.vue?vue&type=script&lang=js&"
export * from "./TextareaStripTags.vue?vue&type=script&lang=js&"
import style0 from "./TextareaStripTags.vue?vue&type=style&index=0&id=0e4dcd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4dcd7a",
  null
  
)

export default component.exports